import React, { useCallback, useEffect } from "react"
import { MdClose } from "react-icons/md"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton, } from "components"
import { thousandSeparator } from "utils"
import classes from "./CheckoutPaymentListCard.module.scss"

const CheckoutPaymentListCard = props => {
  const {
    total,
    cIndex,
    cashType,
    setCashTypes,
    isLinkPay,
    focusedCashType,
    setFocusedCashType
  } = props

  const i18n = useTranslation()[1]

  const location = useLocation()

  const handleDelete = () => {
    setCashTypes((prev) =>
      prev.filter((_, i) => i !== cIndex)
        .map(cashType => ({
          ...cashType,
          amount: Number(total)
        }))
    )
  }

  const handleClickOutSide =
    useCallback((event) => {
      if (!!event.target?.closest("#payment-list-card")) return

      if (!!event.target?.closest("#checkout-keypad")) return

      setFocusedCashType(null)
    }, [])

  useEffect(() => {
    window.addEventListener("click", handleClickOutSide)

    return () => {
      window.removeEventListener("click", handleClickOutSide)
    }
  }, [])

  const disabled =
    isLinkPay ||
    location.state?.mode === "placeOrder"

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      id="payment-list-card"
      onClick={() => !isLinkPay && setFocusedCashType(cIndex)}
      className={clsx(
        classes["card"],
        disabled && classes["disabled"],
        focusedCashType === cIndex && classes["active"]
      )}
    >
      <div
        className={clsx(
          classes["name"],
          isLtr && classes["name-ltr"]
        )}
      >
        {cashType.name}
      </div>
      <div className={classes["row"]}>
        <div className={classes["amount"]}>
          {thousandSeparator(cashType.amount)}
        </div>
        {
          !isLinkPay &&
          <IconButton
            icon={MdClose}
            color="white"
            size={16}
            onClick={() => handleDelete(cIndex)}
            className={clsx(
              classes["buttonAdd"],
              isLtr && classes["buttonAdd-ltr"]
            )}
          />
        }
      </div>
    </div>
  )
}

export default React.memo(CheckoutPaymentListCard)